<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    canSkipLoader: boolean,
  }>(),
  {
    canSkipLoader: false,
  },
);

const emit = defineEmits<{
  // change: [id: number],
  // update: [value: string],
  skip: [],
}>();
</script>

<template>
  <button
    v-if="props.canSkipLoader"
    class="loader-skip-btn"
    type="button"
    @click="emit('skip')"
  >
    Skip
  </button>
</template>

<style lang="scss" scoped>

.loader-skip-btn {
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  cursor: pointer;
  padding: 0.35rem 0.8rem;
  font-size: 0.78rem;
  line-height: 1;

  &:hover {
    border-color: var(--accent, #7f7);
    color: var(--accent, #7f7);
  }
}
</style>
